module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_06_sp-99624f6069fb8cc4cddce1f70894a7df.png";